import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Navbar from '../../../Components/Navbar';
import { Create_Api } from '../../../API/Api_Url';

function ForgotPassword() {
    const navigate = useNavigate();
    const [IsUploading, setIsUploading] = useState(false);

    const [Email, setEmail] = useState('');
    const [Otp, setOtp] = useState('');
    const [Password, setPassword] = useState('');
    const [ShowPassword, setShowPassword] = useState(false);

    const [Step, setStep] = useState(1);

    const handleSendOtp = async () => {
        try {
            if (!Email) return toast.error('Please enter your email');

            setIsUploading(true);
            const res = await Create_Api(`api/user/forgot/otpsend`, { email: Email });

            toast.success(res?.message || 'OTP sent successfully!');
            setStep(2);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to send OTP');
        } finally {
            setIsUploading(false);
        }
    };

    const handleVerifyOtp = async () => {
        try {
            if (!Otp || !Password) return toast.error('Please fill all fields');

            setIsUploading(true);
            const res = await Create_Api(`api/user/forgot/otpverify`, {
                email: Email,
                otp: Otp,
                password: Password
            });

            toast.success(res?.message || 'Password reset successful!');
            setEmail('');
            setOtp('');
            setPassword('');
            setStep(1);
            navigate('/');
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to reset password');
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <>
            <Navbar />
            <div className="signup-container">
                <div className="signup-form">
                    <h3 className="signup-title">Forgot Password</h3>
                    <p className="signup-subtitle">
                        {Step === 1
                            ? 'Enter your email and we will send you an OTP to reset your password.'
                            : 'Enter the OTP sent to your email and your new password.'}
                    </p>
                    {Step === 1 &&
                        <>
                            <label className="signup-label">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={Email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="signup-input"
                                disabled={Step === 2}
                            />
                        </>
                    }
                    {Step === 2 && (
                        <>
                            <label className="signup-label">OTP</label>
                            <input
                                type="text"
                                name="otp"
                                value={Otp}
                                onChange={(e) => setOtp(e.target.value)}
                                className="signup-input"
                            />

                            <label className="signup-label">New Password</label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type={ShowPassword ? 'text' : 'password'}
                                    name="password"
                                    value={Password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="signup-input"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!ShowPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: 10,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'transparent',
                                        border: 'none',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {ShowPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                        </>
                    )}

                    <button
                        onClick={Step === 1 ? handleSendOtp : handleVerifyOtp}
                        className="signup-button"
                        disabled={IsUploading}
                    >
                        {IsUploading ? <span className="loader"></span> : Step === 1 ? 'Send OTP' : 'Verify OTP'}
                    </button>

                    <div className="account-exists">
                        <p>
                            Don’t have an account?{' '}
                            <button
                                className="account-exists-btn"
                                onClick={() => navigate('/ph-UserSignUp')}
                            >
                                Sign Up
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ForgotPassword;
